import { useNavigate } from 'react-router-dom';
import useCreate from '../../useCreate';
import toast from 'react-hot-toast';

const useUpdateIngredient = () => {
  const navigate = useNavigate();
  
  const { setDataToServer } = useCreate({
    url: 'ingredients/update',
    refreshUrl: 'ingredients/list',
    onSuccess: () => {
      toast.success("Ingredient Updated Successfully", {
        position: "top-right",
        duration: 3000
      });
      navigate('/catalog/ingredients');
    }
  });
  
  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return { handleSubmit };
};

export default useUpdateIngredient;
